/*
 * Initializes common UI event listeners and helps massage some of the UI as
 * necessary.
 *
 * @author Jonathon McDonald <jonathon@agencyfusion.com>
 * @author Rachel Wolthuis <rachel@agencyfusion.com>
 * clientid a861b5a800d64401883f2ffe0be744dc
 * accessToken 299189746.a861b5a.356ed350cebb486ca2e9054fad0ccd6d
 */
$(document).ready(function () {
  /* Instagram news feed on home page. */
  $('[data-plug=instafeed]').each(function (index, el) {
    var clientId = '',
      feed = new Instafeed({
        get: 'user',
        userId: $(el).data('user-id'),
        accessToken: '',
        limit: 4,
        resolution: 'low_resolution',
        target: $(el).data('user-id'),
        template: '<div id="thin-padding" class="col-md-3 col-sm-3 col-xs-6"><a href="{{link}}" target="_blank"><img style="height:200px !important; width: 200px !important;" class="img-responsive" src="{{image}}" /></a></div>'
      });

    feed.run();
  });

  /* Add Bootstrap's image responsive class to all images on the page. */
  // $('#body-collection img').addClass('img-responsive');

  /* Navigating Stockists page. */
  $('ul.country-list li').click(function () {
    var selectedCountry = $(this).attr('data-id');

    $('ul.country-list li').removeClass('italic');

    $('.country').hide();
    $('.state').hide();
    $('[data-country=' + selectedCountry + ']').show();
    $(this).addClass('italic');

    $('ul.state-list li').click(function () {
      var selectedState = $(this).attr('data-id');
  	  $('ul.state-list li').removeClass('italic');
      $('.state').hide();
      $('[data-state=' + selectedState + ']').show();
      $(this).addClass('italic');
    });
  });

  /* Expand content on when "Read More" is clicked on the About page. */
  $('#about-content .read-more').on('click', function(event) {
    event.preventDefault();
    $(this).hide();
    $(this).closest('section').find('.teaser').css('height', 'auto');
    $(this).closest('section').find('.show-less').css('display', 'block');
  });

  /* Collapse content when "Show Less" is clicked on the About page. */
  $('#about-content .show-less').on('click', function(event) {
    event.preventDefault();
    $(this).hide();
    $(this).closest('section').find('.teaser').css('height', '60px');
    $(this).closest('section').find('.read-more').css('display', 'block');
  });
});

$(document).ready(function () {
  var originalWidth = 1100;
  var originalHeight = 709;
  var screenWidth = $(window).width();

  /* Resize Bootstrap Carousel items. */
  function resize () {
    var newHeight = (originalHeight / originalWidth) * screenWidth
    //This will only set this._originalHeight once
    $(this).css("height", newHeight);
  }

  $("#vimeo-player").each(resize);

  /* If the document resizes, resize the player. */
  $(document).resize(function () {
      $("#vimeo-player").each(resize);
  });

  function indentDots () {
    var flush = ((screenWidth - 960) / 2) + 45
    //This will only set this._originalHeight once
    $(this).css("left", flush);
  }

  /* Indent the Carousel controls if the screen is sufficiently wide. */
  if (screenWidth > 960) {
    $(".carousel-indicators").each(indentDots);
  }

  /* Remove default form text on focus. */
  $(".emptytext").focus(function () {
    if ($(this).val() == $(this)[0].defaultValue) {
      $(this).val("");
    }
  });

  /* Replace default form text on loss of focus. */
  $(".emptytext").blur(function () {
    if ($(this).val() == "") {
      $(this).val($(this)[0].defaultValue);
    }
  });

  $('.collection-sidebar a').on('click', function(e) {
    $(this).parent('li').toggleClass('target');
  });

  $('#mobile-products-carousel').hammer().on('swipeleft', function(){
    $(this).carousel('next');
  });
  $('#mobile-products-carousel').hammer().on('swiperight', function(){
    $(this).carousel('prev');
  }) ;

  $('#home-carousel').hammer().on('swipeleft', function(){
    $(this).carousel('next');
  });
  $('#home-carousel').hammer().on('swiperight', function(){
    $(this).carousel('prev');
  }) ;

  $('#home-carousel').carousel({
    interval: 4000
  });

  var backwardOneLevel = function () {
    var isSecondLevel = $('.mobile-navigation').hasClass('second-level');
    var isThirdLevel = $('.mobile-navigation').hasClass('third-level');

    if (isSecondLevel) {
      $('.mobile-navigation').removeClass('second-level').addClass('first-level');
    }

    if (isThirdLevel) {
      $('.mobile-navigation').removeClass('third-level').addClass('second-level');
    }
  };

  var isMenuShowing = false;
  $('[data-menu-toggle]').on('click', function () {
    isMenuShowing = !isMenuShowing;

    if (isMenuShowing) {
      $('.mobile-navigation').addClass('open');
      $('.mobile-navigation-overlay').addClass('open');
      $(".mobile-navigation__parent").first().children("a").focus();
    } else {
      $('.mobile-navigation').removeClass('open');
      $('.mobile-navigation-overlay').removeClass('open');
    }
  });

  $('[data-menu-toggle]').keydown(function(event){
    if (event.keyCode == 13) {
      $('.mobile-navigation').removeClass('open');
      $('.mobile-navigation-overlay').removeClass('open');
    }
  });

  $('.mobile-navigation__trigger').on('click', function (e) {
    e.preventDefault();
    $('.mobile-navigation ul > li').each(function (index, element) {
      $(element).removeClass('active');
    });
    $(this).parent().addClass('active');
  });

  $('.mobile-navigation [data-menu-back]').on('click', function (e) {
    e.preventDefault();
    backwardOneLevel();
  });

  $(document).keydown(function(event){
    var keyCode = (event.keyCode ? event.keyCode : event.which);
    if (keyCode == 27 && isMenuShowing) {
      $('.mobile-navigation').removeClass('open');
      $('.mobile-navigation-overlay').removeClass('open');
    }
    isMenuShowing = false;
  });

  // Close search-bar, updated aria-expanded on search-link button and
  // bring focus back to the search-link button when search-bar closes.
  function closeSearchBar(){
    var searchBtn = $('.search-link')
    $('.search-bar').toggle(false);
    searchBtn.attr("aria-expanded", "false")
    searchBtn.focus()
  }

  $('.search-link').on('click', function (e) {
    e.preventDefault();
    this.setAttribute("aria-expanded", "true")
    $('.search-bar').toggle();
    $('.search-bar input[name=q]').focus();
  });
  
  //adding close image-CDP 6/23/2020
  $('#search-close').on('click', function (e) {
    e.preventDefault();
    closeSearchBar()
  });
  
  //adding search for mobile- CDP 6/23/2020
  $('.search-mobile-link').click(function() {
    $('#mobileButtonMenu').click();
  });

  // Add focusout and focusin events to the search-bar. This will close
  // the search-bar with a setTimeout if any of the inputs in search-bar
  // looses focus.
  var searchBarTimeout = null
  $('.search-bar').on('focusin', function (){
    if(searchBarTimeout != null){
      clearTimeout(searchBarTimeout)
    }
  })

  $('.search-bar').on('focusout', function() {
    searchBarTimeout = setTimeout(function(){
      closeSearchBar()
    }, 1000)
  })
  
  var closeFullscreenImages = function () {
    $('.fullscreen-images').remove();
    $('body').removeClass('noscroll');
    unbindEscapeKey('fullscreen-images');
  };
  
  var bindEscapeKey = function (namespace, callback) {
    var escapeKey = 27;
    
    $(document).on('keyup.' + namespace, function (e) {
      if (e.keyCode == escapeKey) {
        callback();
      }
    });
  }
  
  var unbindEscapeKey = function (namespace) {
    $(document).off('keyup.' + namespace);
  }
  
  bindEscapeKey('search-bar', closeSearchBar)

  $('.product-photos').each(function () {
    var $photos = $(this);

    $photos.find('img').on('click', function (e) {
      if (!$('.carousel-indicators').is(':visible')) {
        bindEscapeKey('fullscreen-images', closeFullscreenImages);
        $('body').addClass('noscroll');
        var viewingIndex = $photos.children().index(this);
        var sources = $photos.find('img').map(function () {
          return $(this).data('full-size-src');
        });
        var render = function () {
          $previous.show();
          $next.show();

          if (viewingIndex == 0) {
            $previous.hide();
          }

          if (viewingIndex == sources.length - 1) {
            $next.hide();
          }

          $innerWrapper.html('<img src="' + sources[viewingIndex] + '" />');
        }
        if (!$('.fullscreen-images').length) {
          $('body').append('<div class="fullscreen-images"></div>');
        }
        var $fullscreenImages = $('.fullscreen-images');
        var $outerWrapper = $('<div class="outer-wrapper"></div>');
        var $innerWrapper = $('<div class="inner-wrapper"></div>');
        var $previous = $('<div class="previous">Previous</div>');
        var $next = $('<div class="next">Next</div>');
        var $close = $('<div class="close">Close</div>');
        var $loading = $('<div class="loading"></div>');
        $outerWrapper.append($innerWrapper);

        $outerWrapper.append($loading);
        $fullscreenImages.append($previous);
        $fullscreenImages.append($next);
        $fullscreenImages.append($close);
        $fullscreenImages.append($outerWrapper);

        $close.on('click', function () {
          closeFullscreenImages();
        });

        $next.on('click', function () {
          if (viewingIndex + 1 < sources.length) {
            viewingIndex += 1;
            render();
          }
        });

        $previous.on('click', function () {
          if (viewingIndex - 1 >= 0) {
            viewingIndex -= 1;
            render();
          }
        });

        $(document).on('keyup.fullscreen-images', function (e) {
          var leftArrow = 37;
          var rightArrow = 39;

          switch(e.which) {
            case leftArrow:
              $previous.trigger('click');
              break;
            case rightArrow:
              $next.trigger('click');
              break;
          }
        });

        render();
      }
    });
  });

  var $colorTarget = $('[data-color-target]');
  $('a.swatch').on('mouseenter', function () {
    var $this = $(this);

    $colorTarget.text($this.attr('title'));
  });
  $('a.swatch').on('mouseleave', function () {
    $colorTarget.text('');
  });

  $('#blog-expand-filter').click(function() {
    if ($(this).html() == '+') {
      $(this).html('&ndash;');
    } else {
      $(this).html('+');
    }

    $('.journal__filter-list').toggleClass('hidden');
  })
});
